import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./dashboard.css";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Collapse,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
  DropdownToggle,
} from "reactstrap";
import {
  Table,
  Tooltip,
  //  message
} from "antd";
import { connect } from "react-redux";
// import { addParams } from 'store/route-params/actions';
// import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import DynamicGradeTab from "./components/dymnc-grade";
import moment from "moment";
import MixChart from "components/charts/MixChart";
import IndicatorCard from "components/indicators/IndicatorCard";
// import { login, logout } from 'store/auth/actions';
// import { setData } from 'store/dashdata/actions';
// import { clearData } from 'store/dashdata/actions';
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
// import apiurl from "../../../apiurl";
import axios from "axios";

const mapDispatchToProps = (dispatch) => {
  return {
    // login: (payload) => {
    //     dispatch(login(payload))
    // },
    // c: (payload) => {
    //     dispatch(setData(payload))
    // },
    // clearData: () => {
    //     dispatch(clearData())
    // },
    // logout: () => {
    //     dispatch(logout())
    // },
    // addParams: (payload) => {
    //     dispatch(addParams(payload));
    // }
  };
};

const mapStateToProps = (state, props) => {
  const user = state.user;
  // const user = state.auth.user;
  // const masterDashStat = state.dashData;
  return {
    user: user,
    schoolId: user.schoolId,
    boardId: user.boardId || 7,
    selectedSchoolName: user.selectedSchoolName,
    schoolChainId: user.school ? user.school.schoolChainId : "",
    // schoolChainId: "247",
    // statisticsResponse: masterDashStat.statisticsResponse,
  };
};

// =================================================================================================================

class MasterSchoolDashboard extends Component {
  constructor(props) {
    super(props);

    //===================== STATE ====================

    this.state = {
      insightsAccordionFlag: true,
      insightsTopStudentTblFlag: false,
      gradeAccordianFlag: true,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      pageLoading: true,
      activeTab: "V",
      currentSelectedGrade: "V",
      currentSelectedGradeId: "83",
      studentGradeData: "",
      indicator_gradewisedata: "",
      gradeMaster: "",
      primary: false,
      completionRatedoughnutLabelArr: [],
      completionRatedoughnutDataArr: [],
      inactive_graphLabelArr: [],
      inactive_graphCountArr: [],
      active_graphLabelArr: [],
      active_graphCountArr: [],
      weekly_register_graphLabelArr: [],
      weekly_register_graphCountArr: [],
      inactive_StudentArr: [],
      active_StudentArr: [],
      acadamicYearWiseGradeArr: [],
      total_students: "",
      active_count: "",
      inactive_count: "",
      insightSectionData: {
        maxPercent: {
          grade: "",
          schoolName: "",
        },
        lessPercent: {
          grade: "",
          schoolName: "",
        },
        inactiveCount: {
          grade: "",
          schoolName: "",
        },
        toppers: [],
      },
      schoolId: "",
      boardId: "",
      pagination: {},
      allGradeArr: [],
      toggleAcadamicYrflag: false,
      selectedAcadamicYrGrade: "All",
      mixChartSelectBarTypeStuList: "",
      mixChartSelectGradeStuList: "",
      gradeDisplayVal: "All ",
      toggleLanguageFlag: false,
      selectedSchoolNameArr: [],
      defaultLanguage: "English",
      blocking: true,
      searchFlag: false,
      name: "",
      pageLoader: false,
    };
    // this.chartReference = React.createRef();
    // this.btnGetCardCountDetail = this.btnGetCardCountDetail.bind(this);
    // this.fetchAnalytics = this.fetchAnalytics.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.searchStudentDetail = this.searchStudentDetail.bind(this);
    this.resetStudentDetailTbl = this.resetStudentDetailTbl.bind(this);

    // this.cardInfoBoxtoggle = this.cardInfoBoxtoggle.bind(this);
  }

  popupMessage = (errMsg) => {
    try {
      const alert = this.props.alert;
      alert.error(errMsg);
      // alert.show(errMsg);
      // message.error(errMsg);
    } catch (err) {
      console.log(err);
    }
  };

  toggleInsightsAccordion() {
    let curAccordState = this.state.insightsAccordionFlag;
    let newAccordState = curAccordState === true ? false : true;
    this.setState({
      insightsAccordionFlag: newAccordState,
    });
  }

  toggleGradeAccordion() {
    let curAccordState = this.state.gradeAccordianFlag;
    let newAccordState = curAccordState === true ? false : true;
    this.setState({
      gradeAccordianFlag: newAccordState,
    });
  }

  // =====================

  onClick(lang) {
    i18next.changeLanguage(lang);
  }
  toggleLanguage(event) {
    let curAccordState = this.state.toggleLanguageFlag;
    let newAccordState = curAccordState === true ? false : true;
    this.setState({
      toggleLanguageFlag: newAccordState,
      defaultLanguage: event.currentTarget.textContent,
    });
  }

  //===================  GET CARD COUNT DETAIL ====================

  btnGetCardCountDetail(type) {
    let selectedData = "";
    let tblTypeTitle = "";
    let pagination = {};
    if (type === "registered") {
      selectedData = this.state.weekly_register_StudentArr;
      tblTypeTitle = "Registered Students";
      pagination.total = this.state.registerStudentsPageCount;
    } else if (type === "active") {
      selectedData = this.state.active_StudentArr;
      tblTypeTitle = "Active Students";
      pagination.total = this.state.activeStudentsPageCount;
    } else if (type === "dormant") {
      selectedData = this.state.inactive_StudentArr;
      tblTypeTitle = "Inactive Students";
      pagination.total = this.state.inactiveStudentsPageCount;
    }

    let path = `/student-list`;
    this.props.history.push({
      pathname: path,
      state: {
        category: "card-studentlist",
        type: tblTypeTitle,
        detail: selectedData,
        schoolId: this.state.schoolId,
        boardId: this.state.boardId,
      },
    });
  }

  async changeGradetoggleTab(
    gradedisp,
    gradeid,
    gradeName,
    boardIdOthGrade,
    selectedGradeid
  ) {
    // let login_data = JSON.parse(localStorage.getItem('login_data'));
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    // let finalBoard_id = localStorage.getItem('finalBoard_id');

    localStorage.setItem("selectedGrade_RomanVal", gradedisp);
    localStorage.setItem("selectedGrade_id", gradeid);
    localStorage.setItem("selectedGrade_Name", gradeName);
    localStorage.setItem("boardIdOtherGrades", boardIdOthGrade);
    localStorage.setItem("playedGradeId", selectedGradeid);

    // let selectedGrade = gradedisp;
    this.setState({
      activeTab: gradedisp,
      pageLoader: true,
    });
    // let allGrdArr = this.state.allGradeArr;

    //=========================== Grade Wise Data ========================

    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    let singleSelectFlag = localStorage.getItem("singleSelectFlag");
    let gradeDetailResult;

    if (selectedGrade_id_statisticApi === "") {
      gradeDetailResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
        {
          schoolId: localStorage.getItem("multiselectFlagId"),
          gradeId: gradeid,
          grade: gradeName,
          param: "all",
          page: 1,
          action: singleSelectFlag,
          playedGradeId: selectedGradeid,
        }
      );
    } else {
      gradeDetailResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
        {
          schoolId: localStorage.getItem("multiselectFlagId"),
          gradeId: gradeid,
          grade: gradeName,
          page: 1,
          action: singleSelectFlag,
          playedGradeId: selectedGradeid,
        }
      );
    }
    gradeDetailResult = gradeDetailResult.data;

    let pageObj = {};
    pageObj.total = gradeDetailResult.Grade.stats.students;

    localStorage.setItem(
      "gradeInfoApiResponse",
      JSON.stringify(gradeDetailResult)
    );

    this.setState({
      currentSelectedGrade: this.state.currentSelectedGrade,
      gradeDetails: gradeDetailResult,
      currentSelectedGradeId: gradeid,
      schoolId: localStorage.getItem("multiselectFlagId"),
      boardId: gradeid,
      gradeWiseStudentTblData:
        gradeDetailResult.Grade.stats.gradewise_student_score,
      pagination: pageObj,
      pageLoader: false,
    });
  }

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  //============ DATATABLE CUSTOM SEARCH =====================
  async searchStudentDetail(name, val) {
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    let gradeName = localStorage.getItem("selectedGrade_Name");
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    let singleSelectFlag = localStorage.getItem("singleSelectFlag");
    let playedGradeId = localStorage.getItem("playedGradeId");
    let result;

    this.setState({
      pageLoader: true,
    });

    if (selectedGrade_id_statisticApi === "") {
      result = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/searchuser-dev",
        {
          schoolId: localStorage.getItem("multiselectFlagId"),
          gradeId: this.state.currentSelectedGradeId,
          grade: gradeName,
          param: "all",
          page: val,
          search: name,
          triger: singleSelectFlag,
          playedGradeId: playedGradeId,
        }
      );
    } else {
      result = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/searchuser-dev",
        {
          schoolId: localStorage.getItem("multiselectFlagId"),
          gradeId: this.state.currentSelectedGradeId,
          grade: gradeName,
          page: val,
          search: name,
          triger: singleSelectFlag,
          playedGradeId: playedGradeId,
        }
      );
    }
    result = result.data;

    let pageObj = {};
    pageObj.total = result.search.totalCount;
    pageObj.current = val;
    this.setState({
      gradeWiseStudentTblData: result.search.user,
      pagination: pageObj,
      searchFlag: true,
      name: name,
      pageLoader: false,
    });
  }

  async resetStudentDetailTbl(data) {
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    // let allGrdArr = this.state.allGradeArr;
    // var filterGradArrRes = allGrdArr.filter(obj => {
    //     return obj.grade_id === data.gradeId
    // })
    // let gradeName = filterGradArrRes[0].grade;
    let playedGradeId = localStorage.getItem("playedGradeId");
    let gradeNameNew = localStorage.getItem("selectedGrade_Name");
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    let singleSelectFlag = localStorage.getItem("singleSelectFlag");

    this.setState({
      pageLoader: true,
    });

    let gradeDetailResult;
    if (selectedGrade_id_statisticApi === "") {
      gradeDetailResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
        {
          schoolId: localStorage.getItem("multiselectFlagId"),
          gradeId: data.gradeId,
          grade: gradeNameNew,
          param: "all",
          page: 1,
          action: singleSelectFlag,
          playedGradeId: playedGradeId,
        }
      );
    } else {
      gradeDetailResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
        {
          schoolId: localStorage.getItem("multiselectFlagId"),
          gradeId: data.gradeId,
          grade: gradeNameNew,
          page: 1,
          action: singleSelectFlag,
          playedGradeId: playedGradeId,
        }
      );
    }
    gradeDetailResult = gradeDetailResult.data;

    let pageObj = {};
    pageObj.total = gradeDetailResult.Grade.stats.students;
    pageObj.current = 1;
    this.setState({
      gradeWiseStudentTblData:
        gradeDetailResult.Grade.stats.gradewise_student_score,
      pagination: pageObj,
      searchFlag: false,
      name: "",
      pageLoader: false,
    });
  }

  //============ DATATABLE PAGINATION DYNAMIC CALL ==============

  async handleTableChange(props, pagination) {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    let selectedGrade_Name = localStorage.getItem("selectedGrade_Name");
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    let singleSelectFlag = localStorage.getItem("singleSelectFlag");
    let playedGradeId = localStorage.getItem("playedGradeId");

    this.setState({ pageLoader: true });

    let gradeDetailResult;
    if (this.state.searchFlag === false) {
      if (selectedGrade_id_statisticApi === "") {
        gradeDetailResult = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
          {
            schoolId: localStorage.getItem("multiselectFlagId"),
            gradeId: props.gradeId,
            grade: selectedGrade_Name,
            param: "all",
            page: pagination.current,
            action: singleSelectFlag,
            playedGradeId: playedGradeId,
          }
        );
      } else {
        gradeDetailResult = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
          {
            schoolId: localStorage.getItem("multiselectFlagId"),
            gradeId: props.gradeId,
            grade: selectedGrade_Name,
            page: pagination.current,
            action: singleSelectFlag,
            playedGradeId: playedGradeId,
          }
        );
      }
      gradeDetailResult = gradeDetailResult.data;

      let pageObj = {};
      pageObj.total = gradeDetailResult.Grade.stats.students;
      pageObj.current = pagination.current;

      this.setState({
        gradeWiseStudentTblData:
          gradeDetailResult.Grade.stats.gradewise_student_score,
        pagination: pageObj,
        pageLoader: false,
      });
    } else {
      this.searchStudentDetail(this.state.name, pagination.current);
    }
  }

  //============== CHANGE GRADE FUNCTION =============

  changeGradeFun(selectedGrade) {
    // let pagination = this.state.pagination;

    return (
      <DynamicGradeTab
        data={this.state}
        gradeDetails={this.state.gradeDetails}
        history={this.props.history}
        schoolId={this.state.schoolId}
        boardId={this.state.boardId}
        gradeId={this.state.currentSelectedGradeId}
        pagination={this.state.pagination}
        gradeWiseStudentTblData={this.state.gradeWiseStudentTblData}
        onResetClick={this.resetStudentDetailTbl}
        onSearchClick={this.searchStudentDetail}
        onClickTbl={this.handleTableChange}
      />
    );
  }

  //------------------------ LOAD EXISTING DATA ----------------------------
  loadExistingData() {
    let statisticsResult = JSON.parse(
      localStorage.getItem("statisticsApiResponse")
    );
    if (statisticsResult.statusCode === 200) {
      let selectedSchoolNameStr;
      selectedSchoolNameStr = this.props.user.selectedSchoolName;
      var selectedSchoolNameArr = [];
      if (selectedSchoolNameStr !== undefined) {
        if (selectedSchoolNameStr.length > 0) {
          selectedSchoolNameArr = selectedSchoolNameStr
            .split(",")
            .map(function (item) {
              return item;
            });
        }
      }

      let storedYrDropVal = localStorage.getItem("selectedAcademicYrDisptext");
      let selectedAcademicYrDisptext =
        storedYrDropVal === null
          ? this.state.selectedAcadamicYrGrade
          : storedYrDropVal;
      console.log(statisticsResult.school.schoolName);
      let schoolName =
        statisticsResult.school.schoolName !== undefined
          ? statisticsResult.school.schoolName
          : "";
      // this.props.login({ schoolName: schoolName + ' Master Dashboard' })

      // console.log(this.props.statisticsResult);

      // this.props.login({ schoolName: ' Master Dashboard' })

      // localStorage.setItem('statisticsApiResponse', JSON.stringify(statisticsResult));

      // this.props.setData({statisticsResponse:statisticsResult})

      // this.props.clearData();

      localStorage.setItem(
        "cur_school_name",
        statisticsResult.school.school_name
      );
      localStorage.setItem(
        "cur_board_name",
        statisticsResult.school.board_name
      );

      //================ DEFAULT GRADE VALUE ======================
      // console.log(statisticsResult.school.stats.gradewiseStudent.length)
      // let defaultRomanGradeVal = statisticsResult.school.stats.gradewiseStudent.length !== 0 ? statisticsResult.school.stats.gradewiseStudent[0].gradeRoman : '';
      // let defaultGradeVal = statisticsResult.school.stats.gradewiseStudent.length !== 0 ? statisticsResult.school.stats.gradewiseStudent[0].userGrade : ''; // grade_id replace userGrade
      // let defaultGradeName = statisticsResult.school.stats.gradewiseStudent.length !== 0 ? statisticsResult.school.stats.gradewiseStudent[0].grade : '';
      let allGradeArr = statisticsResult.school.stats.gradewiseStudent;
      let boardIdOtherGrades =
        statisticsResult.school.stats.gradewiseStudent.length !== 0
          ? statisticsResult.school.stats.gradewiseStudent[0].boardId
          : "";

      localStorage.setItem("boardIdOtherGrades", boardIdOtherGrades);

      //=============== ACADAMIC YEAR ============================
      let acadamicYearWiseGradeArr = statisticsResult.school.grade;

      for (let i = 0; i < acadamicYearWiseGradeArr.length; i++) {
        if (acadamicYearWiseGradeArr[i].grade === 11) {
          acadamicYearWiseGradeArr[i].gradeDispVal = "2020 Batch";
        } else if (acadamicYearWiseGradeArr[i].grade === 12) {
          acadamicYearWiseGradeArr[i].gradeDispVal = "2019 Batch";
        } else {
          acadamicYearWiseGradeArr[i].gradeDispVal =
            acadamicYearWiseGradeArr[i].grade;
        }
      }

      let statisticsInsightApiResponse = JSON.parse(
        localStorage.getItem("statisticsInsightApiResponse")
      );

      //================ INSIGHT SECTION ============================
      let insightSectionData = statisticsInsightApiResponse;

      //================= INACTIVE STUDENT CARD DATA =================
      let inactive_StudentArr = statisticsResult.school.inactive_students;
      // let inactive_graphArr = statisticsResult.school.inactive_graph;
      let inactive_graphLabelArr = [];
      let inactive_graphCountArr = [];
      //   for (let i = 0; i < inactive_graphArr.length; i++) {
      //     inactive_graphLabelArr.push(inactive_graphArr[i].date);
      //     inactive_graphCountArr.push(inactive_graphArr[i].count);
      //   }

      //================= ACTIVE STUDENT CARD DATA =================
      let active_StudentArr = statisticsResult.school.active_students;
      // let active_graphArr = statisticsResult.school.active_graph;
      let active_graphLabelArr = [];
      let active_graphCountArr = [];
      //   for (let i = 0; i < active_graphArr.length; i++) {
      //     active_graphLabelArr.push(active_graphArr[i].date);
      //     active_graphCountArr.push(active_graphArr[i].count);
      //   }

      //================= WEEKLY REGISTERED STUDENT CARD DATA =================
      let weekly_register_StudentArr =
        statisticsResult.school.register_students;
      // let weekly_register_graphArr = statisticsResult.school.weekly_register_graph;
      let weekly_register_graphLabelArr = [];
      let weekly_register_graphCountArr = [];
      //   for (let i = 0; i < weekly_register_graphArr.length; i++) {
      //     weekly_register_graphLabelArr.push(weekly_register_graphArr[i].date);
      //     weekly_register_graphCountArr.push(weekly_register_graphArr[i].count);
      //   }

      localStorage.setItem(
        "indicator_gradewisedata",
        JSON.stringify(statisticsResult)
      );

      let total_students = statisticsResult.school.registerStudentsPageCount;
      let active_count = statisticsResult.school.activeStudentsPageCount;
      let inactive_count = statisticsResult.school.inactiveStudentsPageCount;

      let total_studentsDisp = statisticsResult.school.total_students;
      let active_countDisp = statisticsResult.school.active_count;
      let inactive_countDisp = statisticsResult.school.inactive_count;

      let pageObj = {};
      pageObj.defaultPageSize = 10;
      pageObj.total = 0;

      let existingSelectedGradeId = localStorage.getItem("selectedGrade_id");
      let selectedGrade_RomanVal = localStorage.getItem(
        "selectedGrade_RomanVal"
      );

      this.setState(
        {
          indicator_gradewisedata: statisticsResult,
          inactive_graphLabelArr: inactive_graphLabelArr,
          inactive_graphCountArr: inactive_graphCountArr,
          active_graphLabelArr: active_graphLabelArr,
          active_graphCountArr: active_graphCountArr,
          weekly_register_graphLabelArr: weekly_register_graphLabelArr,
          weekly_register_graphCountArr: weekly_register_graphCountArr,
          active_StudentArr: active_StudentArr,
          inactive_StudentArr: inactive_StudentArr,
          weekly_register_StudentArr: weekly_register_StudentArr,
          total_students: total_students,
          active_count: active_count,
          inactive_count: inactive_count,
          total_studentsDisp: total_studentsDisp,
          active_countDisp: active_countDisp,
          inactive_countDisp: inactive_countDisp,
          insightSectionData: insightSectionData,
          currentSelectedGradeId: existingSelectedGradeId,
          // currentSelectedGradeName: defaultGradeName,
          activeTab: selectedGrade_RomanVal,
          schoolId: this.props.schoolId,
          boardId: this.props.boardId,
          acadamicYearWiseGradeArr: acadamicYearWiseGradeArr,
          allGradeArr: allGradeArr,
          pagination: pageObj,
          selectedAcadamicYrGrade: selectedAcademicYrDisptext,
          selectedSchoolName: this.props.location.state.selectedSchoolName,
          selectedSchoolNameArr: selectedSchoolNameArr,
        },
        () => {
          this.setState({
            pageLoading: false,
          });
        }
      );

      let gradeInfoResult = JSON.parse(
        localStorage.getItem("gradeInfoApiResponse")
      );
      if (gradeInfoResult !== null) {
        let pageObjNew = {};
        pageObjNew.defaultPageSize = 10;
        pageObjNew.total = gradeInfoResult.Grade.stats.students;

        this.setState({
          currentSelectedGrade: this.state.currentSelectedGrade,
          gradeDetails: gradeInfoResult,
          gradeWiseStudentTblData:
            gradeInfoResult.Grade.stats.gradewise_student_score,
          pagination: pageObjNew,
        });
      }
    }
  }

  toggleinsightsTopStudentTblAccordion() {
    let curAccordState = this.state.insightsTopStudentTblFlag;
    let newAccordState = curAccordState === true ? false : true;

    this.setState({
      insightsTopStudentTblFlag: newAccordState,
    });
  }

  //===================================================

  cardInfoBoxtoggle(val) {
    this.setState({
      popoverOpen: val,
    });
  }

  onbarGradeClick(val) {
    // let allGrdArr = this.state.allGradeArr;
    // var filterGradArrRes = allGrdArr.filter(obj => {
    //     return obj.gradeRoman === val
    // });
    // let selectedGrdId = filterGradArrRes[0].userGrade;
    // let selectedGrdName = filterGradArrRes[0].grade;
    // this.setState({
    //     mixChartSelectGradeStuList: val
    // })
    // let path = `/principal/students`;
    // this.props.history.push({
    //     pathname: path,
    //     state: {
    //         category: 'mixbar-studentlist',
    //         type: 'mixbar-stulist',
    //         studentType: this.state.mixChartSelectBarTypeStuList,
    //         selectedGradeRomanval: val,
    //         selectedGrdId: selectedGrdId,
    //         selectedGrdName: selectedGrdName,
    //         schoolId: this.state.schoolId,
    //         boardId: this.state.boardId,
    //     }
    // });
  }

  editSchoolSelection() {
    let path = `/select-school`;
    this.props.history.push({
      pathname: path,
    });
    localStorage.setItem("schoolListEditFlag", true);
  }

  onbarTypeClick(val) {
    localStorage.setItem("mixChartSelectBarTypeStuList", val);
    this.setState({
      mixChartSelectBarTypeStuList: val,
    });
  }

  //======================== GET DATA ON INIT ===================

  async getData() {
    console.log(this.props.user);
    console.log(this.props.user.school_id);
    let school_id = localStorage.getItem("multiselectFlagId");
    let schoolName = localStorage.getItem("multiselectSchoolName");
    console.log(schoolName);

    const params = {
      // schoolId: this.props.location.state.schoolId || school_id,
      schoolId: school_id,
      boardId: this.props.boardId,
      // selectedSchoolName: this.props.location.state.selectedSchoolName,
      selectedSchoolName: schoolName,
      schoolChainId: this.props.schoolChainId,
    };
    console.log(this.props.boardId);
    // console.log("PARAMS", params);
    // console.log("PARAM SCHOOL ID", params.schoolId);
    // console.log("PARAM BOARD ID", params.boardId);
    // console.log("schoolChainId", params.schoolChainId);

    //-------------------- ARRAY OF SELECETED SCHOOL NAME ----------------------------------------

    let selectedSchoolNameStr;
    selectedSchoolNameStr = params.selectedSchoolName;
    var selectedSchoolNameArr = [];
    if (selectedSchoolNameStr !== undefined) {
      if (selectedSchoolNameStr.length > 0) {
        selectedSchoolNameArr = selectedSchoolNameStr
          .split(",")
          .map(function (item) {
            return item;
          });
      }
    }

    //------------------------------------------------------------------------------------------

    //--------------------------- ARRAY OF SELECETED SCHOOL IDS ---------------------------------

    let selectedSchoolIdStr;
    let masterSchoolChainId;
    selectedSchoolIdStr = params.schoolId;
    var selectedSchooIdsArr = [];
    if (selectedSchoolIdStr !== undefined) {
      if (selectedSchoolNameStr.length > 0) {
        selectedSchooIdsArr = selectedSchoolIdStr
          .split(",")
          .map(function (item) {
            return item;
          });
      }
    }

    // if (selectedSchooIdsArr.length > 20) {
    masterSchoolChainId = params.schoolChainId;
    // }

    //-------------------------------------------------------------

    // if (params.schoolId !== undefined) {
    //     let paceViewflag = localStorage.setItem('paceViewflag', true);
    //     localStorage.setItem('paceSchool_id', params.schoolId);
    // }

    // if (params.boardId !== undefined) {
    //     localStorage.setItem('paceBoard_id', params.boardId);
    // }

    // let paceSchool_id = localStorage.getItem('paceSchool_id')
    // let paceBoard_id = localStorage.getItem('paceBoard_id');

    // console.log("PACE SCHOOL ID", paceSchool_id)
    // console.log("PACE BOARD ID", paceBoard_id);

    // let defaultSelectedGradeId = this.state.currentSelectedGradeId;
    // let login_data = JSON.parse(localStorage.getItem('login_data'));

    // let localSchoolID = login_data.data.school.school_id
    // let localBoardID = login_data.data.board.board_id

    // console.log("localSchoolID", localSchoolID)
    // console.log("localBoardID", localBoardID)

    let paramSchoolId = params.schoolId;
    let paramBoardId = params.boardId;

    let singleSelectFlag =
      selectedSchooIdsArr.length === 1 ? "singleSchool" : "";

    console.log(selectedSchooIdsArr);
    console.log(masterSchoolChainId);
    console.log(paramBoardId);
    // let finalSchool_id = selectedSchooIdsArr.length > 50 ? masterSchoolChainId : paramSchoolId
    let finalSchool_id = masterSchoolChainId;
    let finalBoard_id = paramBoardId;

    // console.log("FINAL SCHOOL ID - ", finalSchool_id)

    localStorage.setItem("finalSchool_id", finalSchool_id);
    localStorage.setItem("finalBoard_id", finalBoard_id);
    localStorage.setItem("singleSelectFlag", singleSelectFlag);

    let curSchool_id = finalSchool_id;
    let curBoard_id = finalBoard_id;

    //============== GET STATISTICS INFO API CALL ================

    let selectedGradeValStatsApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    if (selectedGradeValStatsApi == null) {
      localStorage.setItem("selectedGrade_id_statisticApi", "");
    }
    let storedYrDropVal = localStorage.getItem("selectedAcademicYrDisptext");
    let selectedAcademicYrDisptext =
      storedYrDropVal === null
        ? this.state.selectedAcadamicYrGrade
        : storedYrDropVal;

    if (finalSchool_id == null) {
      let role = this.props.loggedInUser.role;
      let schoolChainId = this.props.loggedInUser.schoolChainId;
      if (["superadmin"].includes(role)) {
        this.props.history.push(`/chain/login/${schoolChainId}`);
      }
      this.props.logout();
    }

    try {
      let statisticsResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/statistics-dev",
        {
          // schoolId: params.schoolId,
          schoolId: localStorage.getItem("multiselectFlagId"),
          page: 1,
          boardId: params.boardId,
          gradeId: selectedGradeValStatsApi,
          action: singleSelectFlag,
        }
      );
      statisticsResult = statisticsResult.data;

      if (statisticsResult.statusCode === 200) {
        // this.props.login({ schoolName: statisticsResult.school.school_name + ' Master Dashboard' })
        localStorage.setItem(
          "statisticsApiResponse",
          JSON.stringify(statisticsResult)
        );
        // this.props.setData({statisticsResponse:statisticsResult})
        // this.props.clearData();
        localStorage.setItem(
          "cur_school_name",
          statisticsResult.school.school_name
        );
        localStorage.setItem(
          "cur_board_name",
          statisticsResult.school.board_name
        );
        //================ DEFAULT GRADE VALUE ======================
        let defaultRomanGradeVal =
          statisticsResult.school.stats.gradewiseStudent.length !== 0
            ? statisticsResult.school.stats.gradewiseStudent[0].gradeRoman
            : "";
        let defaultGradeVal =
          statisticsResult.school.stats.gradewiseStudent.length !== 0
            ? statisticsResult.school.stats.gradewiseStudent[0].userGrade
            : ""; // grade_id replace userGrade
        let defaultGradeName =
          statisticsResult.school.stats.gradewiseStudent.length !== 0
            ? statisticsResult.school.stats.gradewiseStudent[0].grade
            : "";
        let defaultPlayedGradeId =
          statisticsResult.school.stats.gradewiseStudent.length !== 0
            ? statisticsResult.school.stats.gradewiseStudent[0].grade_id
            : "";
        let allGradeArr = statisticsResult.school.stats.gradewiseStudent;
        let boardIdOtherGrades =
          statisticsResult.school.stats.gradewiseStudent.length !== 0
            ? statisticsResult.school.stats.gradewiseStudent[0].boardId
            : "";
        localStorage.setItem("boardIdOtherGrades", boardIdOtherGrades);
        localStorage.setItem("playedGradeId", defaultPlayedGradeId);

        console.log(statisticsResult.school.school_name);

        //=============== ACADAMIC YEAR ============================
        let acadamicYearWiseGradeArr = statisticsResult.school.grade;
        if (
          finalSchool_id === 469 ||
          statisticsResult.school.school_name === "PACE"
        ) {
          for (let i = 0; i < acadamicYearWiseGradeArr.length; i++) {
            if (acadamicYearWiseGradeArr[i].grade === 11) {
              acadamicYearWiseGradeArr[i].gradeDispVal = "2020 Batch";
            } else if (acadamicYearWiseGradeArr[i].grade === 12) {
              acadamicYearWiseGradeArr[i].gradeDispVal = "2019 Batch";
            } else {
              acadamicYearWiseGradeArr[i].gradeDispVal =
                acadamicYearWiseGradeArr[i].grade;
            }
          }
        } else {
          for (let i = 0; i < acadamicYearWiseGradeArr.length; i++) {
            acadamicYearWiseGradeArr[i].gradeDispVal =
              acadamicYearWiseGradeArr[i].grade;
          }
        }

        //================ INSIGHT SECTION ============================
        // let insightSectionData = statisticsResult.school.insight;

        //================= INACTIVE STUDENT CARD DATA =================
        let inactive_StudentArr = statisticsResult.school.inactive_students;
        // let inactive_graphArr = statisticsResult.school.inactive_graph;
        let inactive_graphLabelArr = [];
        let inactive_graphCountArr = [];
        //   for (let i = 0; i < inactive_graphArr.length; i++) {
        //     inactive_graphLabelArr.push(inactive_graphArr[i].date);
        //     inactive_graphCountArr.push(inactive_graphArr[i].count);
        //   }

        //================= ACTIVE STUDENT CARD DATA =================
        let active_StudentArr = statisticsResult.school.active_students;
        // let active_graphArr = statisticsResult.school.active_graph;
        let active_graphLabelArr = [];
        let active_graphCountArr = [];
        //   for (let i = 0; i < active_graphArr.length; i++) {
        //     active_graphLabelArr.push(active_graphArr[i].date);
        //     active_graphCountArr.push(active_graphArr[i].count);
        //   }

        //================= WEEKLY REGISTERED STUDENT CARD DATA =================
        let weekly_register_StudentArr =
          statisticsResult.school.register_students;
        // let weekly_register_graphArr = statisticsResult.school.weekly_register_graph;
        let weekly_register_graphLabelArr = [];
        let weekly_register_graphCountArr = [];
        //   for (let i = 0; i < weekly_register_graphArr.length; i++) {
        //     weekly_register_graphLabelArr.push(weekly_register_graphArr[i].date);
        //     weekly_register_graphCountArr.push(weekly_register_graphArr[i].count);
        //   }

        localStorage.setItem(
          "indicator_gradewisedata",
          JSON.stringify(statisticsResult)
        );
        localStorage.setItem("selectedGrade_RomanVal", defaultRomanGradeVal);
        let total_students = statisticsResult.school.registerStudentsPageCount;
        let active_count = statisticsResult.school.activeStudentsPageCount;
        let inactive_count = statisticsResult.school.inactiveStudentsPageCount;
        let total_studentsDisp = statisticsResult.school.total_students;
        let active_countDisp = statisticsResult.school.active_count;
        let inactive_countDisp = statisticsResult.school.inactive_count;
        let pageObj = {};
        pageObj.defaultPageSize = 10;
        pageObj.total = 0;

        this.setState(
          {
            indicator_gradewisedata: statisticsResult,
            inactive_graphLabelArr: inactive_graphLabelArr,
            inactive_graphCountArr: inactive_graphCountArr,
            active_graphLabelArr: active_graphLabelArr,
            active_graphCountArr: active_graphCountArr,
            weekly_register_graphLabelArr: weekly_register_graphLabelArr,
            weekly_register_graphCountArr: weekly_register_graphCountArr,
            active_StudentArr: active_StudentArr,
            inactive_StudentArr: inactive_StudentArr,
            weekly_register_StudentArr: weekly_register_StudentArr,
            total_students: total_students,
            active_count: active_count,
            inactive_count: inactive_count,
            total_studentsDisp: total_studentsDisp,
            active_countDisp: active_countDisp,
            inactive_countDisp: inactive_countDisp,
            // insightSectionData: insightSectionData,
            currentSelectedGradeId: defaultGradeVal,
            currentSelectedGradeName: defaultGradeName,
            playedGradeId: defaultPlayedGradeId,
            activeTab: defaultRomanGradeVal,
            schoolId: curSchool_id,
            boardId: curBoard_id,
            acadamicYearWiseGradeArr: acadamicYearWiseGradeArr,
            allGradeArr: allGradeArr,
            pagination: pageObj,
            selectedAcadamicYrGrade: selectedAcademicYrDisptext,
            selectedSchoolName: params.selectedSchoolName,
            selectedSchoolNameArr: selectedSchoolNameArr,
          },
          () => {
            this.setState({
              pageLoading: false,
            });
          }
        );
        //============== GET GRADE INFO API CALL =========================================
        localStorage.setItem(
          "selectedGrade_id",
          this.state.currentSelectedGradeId
        );
        localStorage.setItem(
          "selectedGrade_Name",
          this.state.currentSelectedGradeName
        );

        if (this.state.currentSelectedGradeId !== "") {
          let selectedGrade_id_statisticApi = localStorage.getItem(
            "selectedGrade_id_statisticApi"
          );
          let singleSelectFlag = localStorage.getItem("singleSelectFlag");
          let gradeInfoResult;
          if (
            selectedGrade_id_statisticApi === "" ||
            selectedGrade_id_statisticApi === null
          ) {
            gradeInfoResult = await axios.post(
              "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
              {
                schoolId: localStorage.getItem("multiselectFlagId"),
                gradeId: this.state.currentSelectedGradeId,
                grade: this.state.currentSelectedGradeName,
                playedGradeId: defaultPlayedGradeId,
                param: "all",
                page: 1,
                action: singleSelectFlag,
              }
            );
          } else {
            gradeInfoResult = await axios.post(
              "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
              {
                schoolId: localStorage.getItem("multiselectFlagId"),
                gradeId: this.state.currentSelectedGradeId,
                grade: this.state.currentSelectedGradeName,
                playedGradeId: defaultPlayedGradeId,
                page: 1,
                action: singleSelectFlag,
              }
            );
          }
          gradeInfoResult = gradeInfoResult.data;
          localStorage.setItem(
            "gradeInfoApiResponse",
            JSON.stringify(gradeInfoResult)
          );
          let pageObj = {};
          pageObj.defaultPageSize = 10;
          pageObj.total = gradeInfoResult.Grade.stats.students;
          this.setState({
            currentSelectedGrade: this.state.currentSelectedGrade,
            gradeDetails: gradeInfoResult,
            gradeWiseStudentTblData:
              gradeInfoResult.Grade.stats.gradewise_student_score,
            pagination: pageObj,
          });
        } else {
          let errorMsg = "No Data Found !!";
          this.popupMessage(errorMsg);
        }
      } else {
        let errorMsg = "No Data Found !!";
        let school_name =
          statisticsResult.school.school_name !== undefined
            ? statisticsResult.school.school_name
            : "";
        this.popupMessage(errorMsg);
        // this.props.login({ schoolName: school_name + ' Master Dashboard' })
        this.setState({
          total_students: 0,
          active_count: 0,
          inactive_count: 0,
          blocking: false,
        });
      }

      //============================ INSIGHT API ==================================

      let statisticsInsightData = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/statistics-dev/statisticsinsight-dev",
        {
          schoolId: localStorage.getItem("multiselectFlagId"),
          boardId: params.boardId,
          action: singleSelectFlag,
        }
      );
      statisticsInsightData = statisticsInsightData.data;

      //================ INSIGHT SECTION ============================
      let insightSectionData = statisticsInsightData.insight;
      localStorage.setItem(
        "statisticsInsightApiResponse",
        JSON.stringify(insightSectionData)
      );
      this.setState({
        insightSectionData: insightSectionData,
      });
    } catch (err) {
      console.log(err);
      // window.$utility.showMessage('error', err.message);
      this.setState({
        blocking: false,
      });
    }
  }

  //======================  CHANGE ACADEMIC YEAR DROPDOWN - START =======================

  async toggleAcadamicYr(e, val) {
    console.log(e.target.value, val);
    console.log(e.target.name);

    let gradeDisplayVal = e.target.data;
    let defaultGradeVallocalstrg = localStorage.getItem("selectedGrade_id");
    let newDropValue = e.target.value !== undefined ? e.target.value : "All";
    console.log(newDropValue);
    let selectedGradeValStatsApi =
      e.target.name !== undefined ? e.target.name : "";
    selectedGradeValStatsApi =
      selectedGradeValStatsApi === "All" ? "" : selectedGradeValStatsApi;
    let selectedGradeVal =
      e.target.name !== "All" ? e.target.name : defaultGradeVallocalstrg;
    let selectedGradeIdValue =
      e.target.name !== "All" ? e.target.name : defaultGradeVallocalstrg;
    localStorage.setItem("selectedGrade_id", selectedGradeVal);
    localStorage.setItem(
      "selectedGrade_id_statisticApi",
      selectedGradeValStatsApi
    );
    localStorage.setItem("selectedAcademicYrDisptext", newDropValue);
    let newVal = val === true ? false : true;
    this.setState({
      toggleAcadamicYrflag: newVal,
      selectedAcadamicYrGrade: newDropValue,
      gradeDisplayVal: gradeDisplayVal,
    });
    // let curSchool_id = this.props.schoolId;
    let curBoard_id = this.props.boardId;
    let finalSchool_id = localStorage.getItem("finalSchool_id");
    let singleSelectFlagNew = localStorage.getItem("singleSelectFlag");

    console.log(singleSelectFlagNew);

    if (e.target.name !== "") {
      let statisticsResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/statistics-dev",
        {
          // schoolId: curSchool_id,
          schoolId: localStorage.getItem("multiselectFlagId"),
          page: 1,
          boardId: curBoard_id,
          gradeId: selectedGradeValStatsApi,
          action: singleSelectFlagNew,
        }
      );
      statisticsResult = statisticsResult.data;
      localStorage.setItem(
        "statisticsApiResponse",
        JSON.stringify(statisticsResult)
      );
      //================ DEFAULT GRADE VALUE ======================
      let defaultGradeVal;
      let defaultRomanGradeVal;
      let defaultGradeName;
      let boardIdOtherGrades;
      let defaultPlayedGradeId;
      // if (selectedGradeValStatsApi === '') {
      defaultRomanGradeVal =
        statisticsResult.school.stats.gradewiseStudent.length !== 0
          ? statisticsResult.school.stats.gradewiseStudent[0].gradeRoman
          : "";
      defaultGradeVal =
        statisticsResult.school.stats.gradewiseStudent.length !== 0
          ? statisticsResult.school.stats.gradewiseStudent[0].userGrade
          : ""; // grade_id replace with
      defaultGradeName =
        statisticsResult.school.stats.gradewiseStudent.length !== 0
          ? statisticsResult.school.stats.gradewiseStudent[0].grade
          : "";
      defaultPlayedGradeId =
        statisticsResult.school.stats.gradewiseStudent.length !== 0
          ? statisticsResult.school.stats.gradewiseStudent[0].grade_id
          : "";
      boardIdOtherGrades =
        statisticsResult.school.stats.gradewiseStudent.length !== 0
          ? statisticsResult.school.stats.gradewiseStudent[0].boardId
          : "";
      selectedGradeVal = defaultGradeVal;
      let allGradeArr = statisticsResult.school.stats.gradewiseStudent;
      console.log(allGradeArr);
      localStorage.setItem("boardIdOtherGrades", boardIdOtherGrades);

      // let romanGradeVal = statisticsResult.school.stats.gradewiseStudent.length !== 0 ? statisticsResult.school.stats.gradewiseStudent[0].gradeRoman : ''
      let allGrdArr = this.state.allGradeArr;
      console.log(allGrdArr);
      console.log(selectedGradeIdValue);
      console.log(selectedGradeVal);
      var filterGradArrRes = allGradeArr.filter((obj) => {
        return obj.grade_id === selectedGradeIdValue;
      });
      console.log(filterGradArrRes);
      console.log(filterGradArrRes.length);
      console.log(filterGradArrRes.length !== 0);
      // console.log(filterGradArrRes[0].gradeRoman,defaultRomanGradeVal);
      let selectedRomanGradeVal =
        filterGradArrRes.length !== 0
          ? filterGradArrRes[0].gradeRoman
          : defaultRomanGradeVal;
      let selectedUserGradeVal =
        filterGradArrRes.length !== 0
          ? filterGradArrRes[0].userGrade
          : defaultGradeVal;
      let selectedGradeName =
        filterGradArrRes.length !== 0
          ? filterGradArrRes[0].grade
          : defaultGradeName;
      let selectedPlayedGradeId =
        filterGradArrRes.length !== 0
          ? filterGradArrRes[0].grade_id
          : defaultPlayedGradeId;

      console.log("ROMAN GRADE -", selectedRomanGradeVal);
      console.log("USER GRADE -", selectedUserGradeVal);
      console.log("GRADE NAME -", selectedGradeName);
      console.log("PLAYED GRADE-", selectedPlayedGradeId);

      localStorage.setItem("playedGradeId", selectedPlayedGradeId);

      if (selectedGradeValStatsApi === "") {
        localStorage.setItem("selectedGrade_id", selectedUserGradeVal);
      }

      //================ INSIGHT SECTION ============================
      // let insightSectionData = statisticsResult.school.insight

      //================= INACTIVE STUDENT CARD DATA =================
      let inactive_StudentArr = statisticsResult.school.inactive_students;
      // let inactive_graphArr = statisticsResult.school.inactive_graph;
      let inactive_graphLabelArr = [];
      let inactive_graphCountArr = [];
      //   for (let i = 0; i < inactive_graphArr.length; i++) {
      //     inactive_graphLabelArr.push(inactive_graphArr[i].date);
      //     inactive_graphCountArr.push(inactive_graphArr[i].count);
      //   }

      //================= ACTIVE STUDENT CARD DATA =================
      let active_StudentArr = statisticsResult.school.active_students;
      // let active_graphArr = statisticsResult.school.active_graph;
      let active_graphLabelArr = [];
      let active_graphCountArr = [];
      //   for (let i = 0; i < active_graphArr.length; i++) {
      //     active_graphLabelArr.push(active_graphArr[i].date);
      //     active_graphCountArr.push(active_graphArr[i].count);
      //   }

      //================= WEEKLY REGISTERED STUDENT CARD DATA =================
      let weekly_register_StudentArr =
        statisticsResult.school.register_students;
      // let weekly_register_graphArr = statisticsResult.school.weekly_register_graph;
      let weekly_register_graphLabelArr = [];
      let weekly_register_graphCountArr = [];
      //   for (let i = 0; i < weekly_register_graphArr.length; i++) {
      //     weekly_register_graphLabelArr.push(weekly_register_graphArr[i].date);
      //     weekly_register_graphCountArr.push(weekly_register_graphArr[i].count);
      //   }
      localStorage.setItem(
        "indicator_gradewisedata",
        JSON.stringify(statisticsResult)
      );
      let total_students = statisticsResult.school.registerStudentsPageCount;
      let active_count = statisticsResult.school.activeStudentsPageCount;
      let inactive_count = statisticsResult.school.inactiveStudentsPageCount;
      let total_studentsDisp = statisticsResult.school.total_students;
      let active_countDisp = statisticsResult.school.active_count;
      let inactive_countDisp = statisticsResult.school.inactive_count;
      let pageObj = {};
      pageObj.defaultPageSize = 10;
      pageObj.total = 211;

      this.setState(
        {
          indicator_gradewisedata: statisticsResult,
          inactive_graphLabelArr: inactive_graphLabelArr,
          inactive_graphCountArr: inactive_graphCountArr,
          active_graphLabelArr: active_graphLabelArr,
          active_graphCountArr: active_graphCountArr,
          weekly_register_graphLabelArr: weekly_register_graphLabelArr,
          weekly_register_graphCountArr: weekly_register_graphCountArr,
          active_StudentArr: active_StudentArr,
          inactive_StudentArr: inactive_StudentArr,
          weekly_register_StudentArr: weekly_register_StudentArr,
          total_students: total_students,
          active_count: active_count,
          inactive_count: inactive_count,
          total_studentsDisp: total_studentsDisp,
          active_countDisp: active_countDisp,
          inactive_countDisp: inactive_countDisp,
          // insightSectionData: insightSectionData,
          currentSelectedGradeId: selectedUserGradeVal,
          activeTab: selectedRomanGradeVal,
          allGradeArr: allGradeArr,
          pagination: pageObj,
        },
        () => {
          this.setState({
            pageLoading: false,
          });
        }
      );

      // let allGrdArrNew = this.state.allGradeArr;
      // var filterGradArrResNew = allGrdArrNew.filter(obj => {
      //     return obj.userGrade === Number(selectedGradeVal)
      // })
      // let gradeName = filterGradArrResNew.length !== 0 ? filterGradArrResNew[0].grade : selectedGradeName;
      let gradeName = selectedGradeName;
      localStorage.setItem("selectedGrade_Name", gradeName);
      let singleSelectFlag = localStorage.getItem("singleSelectFlag");

      if (selectedGradeVal !== "") {
        let gradeDetailResult;
        if (selectedGradeValStatsApi === "") {
          gradeDetailResult = await axios.post(
            "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
            {
              schoolId: localStorage.getItem("multiselectFlagId"),
              gradeId: selectedUserGradeVal,
              grade: gradeName,
              param: "all",
              page: 1,
              action: singleSelectFlag,
              playedGradeId: selectedPlayedGradeId,
            }
          );
        } else {
          gradeDetailResult = await axios.post(
            "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal-master-api/getgradeinfo-dev",
            {
              schoolId: localStorage.getItem("multiselectFlagId"),
              gradeId: selectedUserGradeVal,
              grade: gradeName,
              page: 1,
              action: singleSelectFlag,
              playedGradeId: selectedPlayedGradeId,
            }
          );
        }
        gradeDetailResult = gradeDetailResult.data;
        localStorage.setItem(
          "gradeInfoApiResponse",
          JSON.stringify(gradeDetailResult)
        );
        pageObj = {};
        pageObj.total = gradeDetailResult.Grade.stats.students;

        this.setState({
          currentSelectedGrade: this.state.currentSelectedGrade,
          gradeDetails: gradeDetailResult,
          gradeWiseStudentTblData:
            gradeDetailResult.Grade.stats.gradewise_student_score,
          pagination: pageObj,
        });
      } else {
        let errorMsg = "No Data Found !!";
        this.popupMessage(errorMsg);

        pageObj.total = 0;
        this.setState({
          // currentSelectedGrade: this.state.currentSelectedGrade,
          gradeDetails: {
            Grade: {
              stats: {
                students: "",
                score: {
                  overall_score: [],
                },
              },
            },
          },
          gradeWiseStudentTblData: [],
          // pagination: pageObj,
        });
      }
    }
  }
  //======================  CHANGE ACADEMIC YEAR DROPDOWN - END =======================

  //====================== GET TOPPER STUDENT DETAIL - START ==========================

  getTopperStudentDetail(selectedRowKeys, selectedRows) {
    // console.log(selectedRows)
    let selectedUser_id = selectedRows.userId;
    // let selectedGrade_id = localStorage.getItem('selectedGrade_id'); // Grade ID
    let selectedGrade_id = selectedRows.GradeId;
    let selectedBoard_id = localStorage.getItem("finalBoard_id"); // Board ID
    // let selectedGrade_Name = localStorage.getItem('selectedGrade_Name');
    let selectedGrade_Name = selectedRows.userGrade;
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    let boardIdOtherGrades = localStorage.getItem("boardIdOtherGrades");

    let payload;
    if (selectedGrade_id_statisticApi === "") {
      payload = {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: boardIdOtherGrades,
        grade: selectedGrade_Name,
        filter: "day",
        param: "all",
      };
    } else {
      payload = {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: selectedBoard_id,
        grade: selectedGrade_Name,
        filter: "day",
      };
    }

    // this.props.addParams(payload);
    // this.props.history.push("/parent/dashboard");
    // window.scrollTo(0, 0);
    this.props.history.push({
      pathname: "/student-detail",
      state: {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: selectedBoard_id,
        grade: selectedGrade_Name,
        filter: "day",
      },
    });
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    let statsApiResponse = JSON.parse(
      localStorage.getItem("statisticsApiResponse")
    );
    let schoolListEditFlag = localStorage.getItem("schoolListEditFlag");
    // if (statsApiResponse === null || schoolListEditFlag === "true") {
    this.getData();
    localStorage.setItem("schoolListEditFlag", false);
    // } else {
    //     this.loadExistingData();
    // }
  }

  render() {
    const { t, i18n } = this.props;
    let indicator_gradewisedata = this.state.indicator_gradewisedata;

    if (indicator_gradewisedata !== "") {
      let StudentGradeWiseAvg =
        indicator_gradewisedata.school.stats.gradewiseStudent;
      //==========='CHART 01'===========//
      let ovsGrades = [];
      let activeStudentCount = [];
      let inactiveStudentCount = [];
      let ovAvgScore = [];

      for (let i = 0; i < StudentGradeWiseAvg.length; i++) {
        ovsGrades.push(StudentGradeWiseAvg[i].gradeRoman);
        let activeStudentNum =
          StudentGradeWiseAvg[i].activeStudentCount !== undefined
            ? StudentGradeWiseAvg[i].activeStudentCount
            : 0;
        let inactiveStudentNum =
          StudentGradeWiseAvg[i].inactivStudentCount !== undefined
            ? StudentGradeWiseAvg[i].inactivStudentCount
            : 0;
        activeStudentCount.push(activeStudentNum);
        inactiveStudentCount.push(inactiveStudentNum);
        ovAvgScore.push(StudentGradeWiseAvg[i].avgScore);
      }

      //============== Card - 1 Registered User Bar Chart ======================
      // const registereduser_cardChartData = {
      //     labels: this.state.weekly_register_graphLabelArr,
      //     datasets: [
      //         {
      //             label: 'Registered Students',
      //             backgroundColor: 'rgba(255,255,255,.3)',
      //             borderColor: 'transparent',
      //             data: this.state.weekly_register_graphCountArr,
      //         },
      //     ],
      // };

      // const registereduser_cardChartOpts = {
      //     tooltips: {
      //         enabled: false,
      //         custom: CustomTooltips
      //     },
      //     maintainAspectRatio: false,
      //     legend: {
      //         display: false,
      //     },
      //     scales: {
      //         xAxes: [
      //             {
      //                 display: false,
      //                 barPercentage: 0.6,
      //             }],
      //         yAxes: [
      //             {
      //                 display: false,
      //             }],
      //     },
      // };

      //============== Card - 2 Active User Line Chart ======================
      // const activeuser_cardChartData = {
      //     labels: this.state.active_graphLabelArr,
      //     datasets: [
      //         {
      //             label: 'Active Students',
      //             backgroundColor: '#71B37C',
      //             borderColor: 'rgba(255,255,255,.55)',
      //             data: this.state.active_graphCountArr,
      //         },
      //     ],
      // };

      // const activeuser_cardChartOpts = {
      //     tooltips: {
      //         enabled: false,
      //         custom: CustomTooltips
      //     },
      //     maintainAspectRatio: false,
      //     legend: {
      //         display: false,
      //     },
      //     scales: {
      //         xAxes: [
      //             {
      //                 display: false,
      //             }],
      //         yAxes: [
      //             {
      //                 display: false,
      //             }],
      //     },
      //     elements: {
      //         line: {
      //             borderWidth: 2,
      //         },
      //         point: {
      //             radius: 0,
      //             hitRadius: 10,
      //             hoverRadius: 4,
      //         },
      //     },
      // };

      //============== Card - 3 Inactive User Line Chart ======================
      // const inactiveuser_cardChartData = {
      //     labels: this.state.inactive_graphLabelArr,
      //     datasets: [
      //         {
      //             label: 'Dormant Students',
      //             backgroundColor: '#d93737',
      //             borderColor: 'rgba(255,255,255,.55)',
      //             data: this.state.inactive_graphCountArr,
      //         },
      //     ],
      // };

      // const inactiveuser_cardChartOpts = {
      //     tooltips: {
      //         enabled: false,
      //         custom: CustomTooltips
      //     },
      //     maintainAspectRatio: false,
      //     legend: {
      //         display: false,
      //     },
      //     scales: {
      //         xAxes: [
      //             {
      //                 gridLines: {
      //                     color: 'transparent',
      //                     zeroLineColor: 'transparent',
      //                 },
      //                 ticks: {
      //                     fontSize: 2,
      //                     fontColor: 'transparent',
      //                 },

      //             }],
      //         yAxes: [
      //             {
      //                 display: false,
      //                 ticks: {
      //                     display: false,
      //                     min: Math.min.apply(Math, inactiveuser_cardChartData.datasets[0].data) - 5,
      //                     max: Math.max.apply(Math, inactiveuser_cardChartData.datasets[0].data) + 5,
      //                 },
      //             }],
      //     },
      //     elements: {
      //         line: {
      //             borderWidth: 1,
      //         },
      //         point: {
      //             radius: 4,
      //             hitRadius: 10,
      //             hoverRadius: 4,
      //         },
      //     }
      // }
      // =====================================================================

      let total_studentsIndicatorNum = this.state.total_studentsDisp;
      let active_countIndicatorNum = this.state.active_countDisp;
      let inactive_countIndicatorNum = this.state.inactive_countDisp;
      let insightSectionData = this.state.insightSectionData;

      const columns = [
        {
          title: "Grade Played",
          dataIndex: "grade",
          key: "grade",
          render: (text) => <span>{text}</span>,
        },
        {
          title: "User Id",
          dataIndex: "userId",
          key: "userId",
        },
        {
          title: "User Grade",
          dataIndex: "userGrade",
          key: "userGrade",
          render: (text) => <span>{text}</span>,
        },
        // {
        //     title: 'Score',
        //     dataIndex: 'score',
        //     key: 'score',
        // },
        {
          title: "Full Name",
          dataIndex: "fullname",
          key: "fullname",
        },
        {
          title: "School name",
          dataIndex: "schoolName",
          key: "schoolName",
        },
        {
          title: "",
          dataIndex: "",
          key: "x",
          align: "right",          
          render: (selectedRowKeys, selectedRows) => (
            <Button
              className="btn btn-outline"
              onClick={() =>
                this.getTopperStudentDetail(selectedRowKeys, selectedRows)
              }
            >
              {" "}
              View details <icon className="icon-next"></icon>
            </Button>
          ),
        },
      ];

      let insightSecTopperDataFin = insightSectionData.toppers;
      for (let i = 0; i < insightSecTopperDataFin.length; i++) {
        insightSecTopperDataFin[i].key = i;
      }
      const insightTopperdata = insightSecTopperDataFin;
      let acadamicYearWiseGradeArr = this.state.acadamicYearWiseGradeArr;
      const selectedSchoolNameArr = this.state.selectedSchoolNameArr;

      localStorage.setItem(
        "selectedSchoolNameArr",
        JSON.stringify(selectedSchoolNameArr)
      );

      return (
        <div id="CommonPageHolder">
          <div className="container-fluid animated fadeIn">
            <div className="row no-gutters top-fixed-bar head-bread-crumb-dashboard">
              <div className="col bread-crumb px-0">Super Admin Dashboard</div>
              <div className="back-nav-btn text-right"></div>
            </div>
            <Card>
              <CardBody className="custyrdrpcls">
                <div className="row width-100 no-gutters">
                  <div className="col-md-12 d-f-c">
                    <div className="width-10">
                      {" "}
                      <strong>Selected Schools - </strong>
                    </div>
                    <div className="schl_span width-80">
                      {selectedSchoolNameArr.map((object, i) => (
                        <span obj={object} key={i}>
                          {object}
                        </span>
                      ))}
                    </div>
                    <div className="width-10">
                      <div className="custdrpalg">
                        <span> Grade : </span>
                        <ButtonDropdown
                          className="mr-1"
                          isOpen={this.state.toggleAcadamicYrflag}
                          toggle={(e) => {
                            this.toggleAcadamicYr(
                              e,
                              this.state.toggleAcadamicYrflag
                            );
                          }}
                        >
                          <DropdownToggle caret color="primary">
                            {this.state.selectedAcadamicYrGrade}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem name="All" value="All">
                              All
                            </DropdownItem>
                            {acadamicYearWiseGradeArr.map((object, i) => {
                              return (
                                //  <DropdownItem name={object.gradeId} value={object.grade} key={i}>{object.grade}</DropdownItem>
                                <DropdownItem
                                  name={object.gradeId}
                                  //  value={object.grade}
                                  value={object.gradeDispVal}
                                  //  data={object.gradeDispVal}
                                  key={i}
                                >
                                  {object.gradeDispVal}
                                </DropdownItem>
                              );
                            })}
                          </DropdownMenu>
                        </ButtonDropdown>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-2">
                    <ButtonDropdown isOpen={this.state.toggleLanguageFlag} toggle={(e) => { this.toggleLanguage(e, this.state.toggleLanguageFlag) }}>
                                <div className="schl_span">
                                <strong>Language - </strong>    
                                </div>
                                    <DropdownToggle caret>
                                    {this.state.defaultLanguage}
                                </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={this.onClick.bind(this, 'en')}>English</DropdownItem>
                                        <DropdownItem onClick={this.onClick.bind(this, 'hi')}>Hindi</DropdownItem>
                                    </DropdownMenu>
                                </ButtonDropdown>
                  </div> */}

                  <div className="row width-100 no-gutters py-2">
                    <div className="col-md-12 text-center">
                      <Button
                        id="Popover1"
                        className="btn btn-primary"
                        onClick={this.editSchoolSelection.bind(this)}
                      >
                        Add/Remove Schools
                      </Button>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>

            {/* ==================================== SUMMARY CARD BOX  - START ===================================== */}

            <Row className="d-f-c">
              <IndicatorCard
                count={total_studentsIndicatorNum.toString()}
                label={"Registered Students"}
                // label={t('Thanks.1')}
                bgcolor={"#55b2ff"}
                icon={"registered-students"}
                onClick={this.btnGetCardCountDetail.bind(this, "registered")}
                // chartType={"bar"}
                // chartData={registereduser_cardChartData}
                // chartOption={registereduser_cardChartOpts}
                // chartHeight={80}
                popoverOpen={this.state.popoverOpen}
                popoverId={"registered"}
                popoverDesp={
                  "The total number of students registered with STEPapp."
                }
                onInfobtnClick={this.cardInfoBoxtoggle.bind(this)}
                disabled={total_studentsIndicatorNum === 0}
              />
              <IndicatorCard
                count={active_countIndicatorNum.toString()}
                label={"Active Students"}
                // label={t('Thanks.2')}
                bgcolor={"#71B37C"}
                icon={"active-students"}
                onClick={this.btnGetCardCountDetail.bind(this, "active")}
                // chartType={"line"}
                // chartData={activeuser_cardChartData}
                // chartOption={activeuser_cardChartOpts}
                // chartHeight={80}
                popoverOpen={this.state.popoverOpen}
                popoverId={"active"}
                popoverDesp={
                  "The total number of students who have completed/played any chapter or topic. The more they play, the more they learn!"
                }
                onInfobtnClick={this.cardInfoBoxtoggle.bind(this)}
                disabled={active_countIndicatorNum === 0}
              />
              <IndicatorCard
                count={inactive_countIndicatorNum.toString()}
                label={"Inactive Students"}
                // label={t('Thanks.3')}
                bgcolor={"#d93737"}
                icon={"inactive-students"}
                onClick={this.btnGetCardCountDetail.bind(this, "dormant")}
                // chartType={"line"}
                // chartData={inactiveuser_cardChartData}
                // chartOption={inactiveuser_cardChartOpts}
                // chartHeight={80}
                popoverOpen={this.state.popoverOpen}
                popoverId={"dormant"}
                popoverDesp={"Total Number of Inactive Students"}
                onInfobtnClick={this.cardInfoBoxtoggle.bind(this)}
                disabled={inactive_countIndicatorNum === 0}
              />
            </Row>

            {/* ==================================== SUMMARY CARD BOX  - END ===================================== */}
            <Row>
              <Col md="12">
                <Card>
                  {/* ==================================== CHART - 01 - OVERALL SCORE  - START ===================================== */}
                  <CardBody>
                    <CardTitle className="mb-0">
                      Number of Students Grade-wise &nbsp;&nbsp;{" "}
                      <Tooltip title="The graph represents the average score of the students, number of active and inactive students of the respective grades.">
                        {" "}
                        <icon
                          className="icon-inform"
                          aria-hidden="true"
                        ></icon>{" "}
                      </Tooltip>
                    </CardTitle>
                    {/* <CardTitle className="mb-0">{t('Why.1')}</CardTitle> */}
                    <div
                      className="chart-wrapper"
                      style={{ marginTop: 40 + "px" }}
                    >
                      <MixChart
                        labels={ovsGrades}
                        bar1data={activeStudentCount}
                        bar2data={inactiveStudentCount}
                        linedata={ovAvgScore}
                        onbarGrdClick={this.onbarGradeClick.bind(this)}
                        onbarTypClick={this.onbarTypeClick.bind(this)}
                        height={324}
                      />
                    </div>
                  </CardBody>
                  {/* ==================================== CHART - 01 - OVERALL SCORE  - END ===================================== */}
                </Card>
              </Col>
            </Row>

            {/* ------------------------------------------------------------------------------------------------- */}
            <div className=" p-0">
              <div className="row width-100">
                <div className="col-md-12">
                  <ul class="nav nav-tabs " id="myTab" role="tablist">
                    <li class="nav-item width-50 text-center ">
                      <a
                        class=" nav-link active"
                        id="home-tab"
                        data-toggle="tab"
                        href="#home"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        <icon className="icon-summary font-icon-tab"></icon>
                        Grade Wise Summary
                      </a>
                    </li>
                    <li class="nav-item width-50 text-center ">
                      <a
                        class=" nav-link"
                        id="profile-tab"
                        data-toggle="tab"
                        href="#profile"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        <icon className="icon-insights font-icon-tab"></icon>
                        Insights
                      </a>
                    </li>
                  </ul>

                  <div class="tab-content">
                    <div
                      class="tab-pane active"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <Row>
                        <Col xs="12" md="12" className="mb-12">
                          <Nav tabs className="py-4">
                            {StudentGradeWiseAvg.map((object, i) => (
                              <NavItem key={i}>
                                <div
                                  tag="div"
                                  blocking={this.state.pageLoader}
                                  keepInView
                                >
                                  <NavLink
                                    className="custom-tab"
                                    key={i}
                                    active={
                                      this.state.activeTab === object.gradeRoman
                                    }
                                    onClick={() => {
                                      this.changeGradetoggleTab(
                                        object.gradeRoman,
                                        object.userGrade,
                                        object.grade,
                                        object.boardId,
                                        object.grade_id
                                      );
                                    }} // grade_id replace userGrade
                                  >
                                    <icon className="icon-chapters"></icon>{" "}
                                    Grade - {object.gradeRoman}
                                  </NavLink>
                                </div>
                                {/* </BlockUi> */}
                              </NavItem>
                            ))}
                          </Nav>
                          <TabContent activeTab={this.state.activeTab}>
                            {this.changeGradeFun(this.state.activeTab)}
                          </TabContent>
                        </Col>
                      </Row>
                    </div>
                    <div
                      class="tab-pane py-4"
                      id="profile"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                    >
                      <CardBody>
                        <Alert color="primary">
                          {/* 1. Class {this.state.insightSectionData.maxPercent.grade} has most  %  students in 90-100% in {insightSectionData.maxPercent.schoolName}. */}
                          1. Class{" "}
                          {this.state.insightSectionData.maxPercent.grade},{" "}
                          {insightSectionData.maxPercent.schoolName} has the
                          most no. of students in 90-100%. They deserve a gold
                          star for their impeccable learning outcomes!
                        </Alert>
                        <Alert color="success">
                          {/* 2. Class {this.state.insightSectionData.lessPercent.grade} has most % students below 50% in {insightSectionData.lessPercent.schoolName}. */}
                          2. Class{" "}
                          {this.state.insightSectionData.lessPercent.grade},{" "}
                          {insightSectionData.lessPercent.schoolName} has the
                          most no. of students below 50%. Encourage them to
                          relearn and retest their concepts until they have
                          complete clarity!
                        </Alert>
                        <Alert color="danger">
                          {/* 3. Class {this.state.insightSectionData.inactiveCount.grade} has max number of inactive students in {insightSectionData.inactiveCount.schoolName}. */}
                          3. Class{" "}
                          {this.state.insightSectionData.inactiveCount.grade},{" "}
                          {insightSectionData.inactiveCount.schoolName} has the
                          maximum number of inactive students. They might need a
                          little push of motivation from the teachers to enjoy
                          the benefits of gamified learning.
                        </Alert>

                        <Alert color="info">
                          <div className="d-f-c-b">
                            See list of toppers of each class here.
                            <button
                              className="btn btn-outline-none float-right"
                              onClick={() =>
                                this.toggleinsightsTopStudentTblAccordion()
                              }
                            >
                              <icon
                                className={`icon-${
                                  this.state.insightsTopStudentTblFlag === true
                                    ? "minus"
                                    : "plus"
                                } `}
                                aria-hidden="true"
                              ></icon>
                            </button>
                          </div>
                          <Collapse
                            isOpen={this.state.insightsTopStudentTblFlag}
                          >
                            <Table
                              columns={columns}
                              dataSource={insightTopperdata}
                            />
                          </Collapse>
                        </Alert>
                      </CardBody>
                    </div>
                  </div>
                </div>
              </div>

              {/* 
                            <Row>
                                <Col>
                                    <Card>
                                        <CardHeader>
                                            <Button block color="link" className="text-left m-0 p-0"
                                                onClick={() => this.toggleGradeAccordion()}
                                                aria-controls="collapseOne">
                                                <i className="fa fa-university"></i><strong>   Grade Wise Summary</strong>
                                                <i className="fa fa-university"></i><strong> {t('Why.2')}</strong>
                                                <div className="card-header-actions">
                                                    <i className={`fa ${this.state.gradeAccordianFlag === true ? 'fa-minus-square' : 'fa-plus-square'} `} aria-hidden="true"></i>
                                                </div>
                                            </Button>
                                        </CardHeader>
                                        <Collapse
                                            isOpen={this.state.gradeAccordianFlag}
                                        >
                                            <CardBody>
                                                <Row>
                                                    <Col xs="12" md="12" className="mb-12">
                                                        <Nav tabs>
                                                            {StudentGradeWiseAvg.map((object, i) =>
                                                                <NavItem key={i}>
                                                                    <BlockUi tag="div" blocking={this.state.pageLoader} keepInView>
                                                                        <NavLink
                                                                            key={i}
                                                                            active={this.state.activeTab === object.gradeRoman}
                                                                            onClick={() => { this.changeGradetoggleTab(object.gradeRoman, object.userGrade, object.grade, object.boardId, object.grade_id); }} // grade_id replace userGrade
                                                                        >
                                                                            <i className="icon-calculator"></i> Grade - {object.gradeRoman}
                                                                        </NavLink>
                                                                    </BlockUi>
                                                                </NavItem>
                                                            )}
                                                        </Nav>
                                                        <TabContent activeTab={this.state.activeTab}>
                                                            {this.changeGradeFun(this.state.activeTab)}
                                                        </TabContent>
                                                    </Col>
                                                </Row>
                                                <br />
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                </Col>
                            </Row>

                            <Row> 

                                <Col xl="12">
                                    <Card>
                                        <CardHeader>
                                            <Button block color="link" className="text-left m-0 p-0"
                                                onClick={() => this.toggleInsightsAccordion()}
                                                aria-controls="collapseOne">
                                                <i className="fa fa-newspaper-o"></i><strong>   Insights</strong>
                                                <div className="card-header-actions">
                                                    <i className={`fa ${this.state.insightsAccordionFlag === true ? 'fa-minus-square' : 'fa-plus-square'} `} aria-hidden="true"></i>
                                                </div>
                                            </Button>
                                        </CardHeader>
                                        <Collapse
                                            isOpen={this.state.insightsAccordionFlag}
                                        >
                                            <CardBody>
                                                <Alert color="primary">
                                                    1. Class {this.state.insightSectionData.maxPercent.grade} has most  %  students in 90-100% in {insightSectionData.maxPercent.schoolName}.
                                            1. Class {this.state.insightSectionData.maxPercent.grade}, {insightSectionData.maxPercent.schoolName} has the most no. of students in 90-100%. They deserve a gold star for their impeccable learning outcomes!
                                        </Alert>
                                                <Alert color="success">
                                                    2. Class {this.state.insightSectionData.lessPercent.grade} has most % students below 50% in {insightSectionData.lessPercent.schoolName}.
                                            2. Class {this.state.insightSectionData.lessPercent.grade}, {insightSectionData.lessPercent.schoolName} has the most no. of students below 50%. Encourage them to relearn and retest their concepts until they have complete clarity!
                                        </Alert>
                                                <Alert color="danger">
                                                    3. Class {this.state.insightSectionData.inactiveCount.grade} has max number of inactive students in {insightSectionData.inactiveCount.schoolName}.
                                            3. Class {this.state.insightSectionData.inactiveCount.grade}, {insightSectionData.inactiveCount.schoolName} has the maximum number of inactive students. They might need a little push of motivation from the teachers to enjoy the benefits of gamified learning.
                                        </Alert>

                                                <Alert color="info">
                                                    See list of toppers of each class here.
                                            <button className="btn btn-link float-right" onClick={() => this.toggleinsightsTopStudentTblAccordion()}>
                                                        <i className={`fa ${this.state.insightsTopStudentTblFlag === true ? 'fa-minus-square' : 'fa-plus-square'} `} aria-hidden="true"></i>
                                                    </button>
                                                    <Collapse
                                                        isOpen={this.state.insightsTopStudentTblFlag}
                                                    >
                                                        <Table columns={columns} dataSource={insightTopperdata} />
                                                    </Collapse>
                                                </Alert>

                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                </Col>

                            </Row>*/}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="CommonPageHolder">
          <div className="container-fluid">
            <BlockUi tag="div" blocking={this.state.blocking} keepInView>
              {/* ==================================== SUMMARY CARD BOX  - START ===================================== */}
              <Row>
                <IndicatorCard
                  count={"0"}
                  label={"Registered Students"}
                  bgcolor={"#59b4ff"}
                  icon={"registered-students"}
                  onClick={this.btnGetCardCountDetail.bind(this, "registered")}
                  // chartType={"bar"}
                  // chartData={registereduser_cardChartData}
                  // chartOption={registereduser_cardChartOpts}
                  // chartHeight={80}
                  popoverOpen={this.state.popoverOpen}
                  popoverId={"registered"}
                  popoverDesp={"Total Number of Registered Students"}
                  onInfobtnClick={this.cardInfoBoxtoggle.bind(this)}
                  disabled={true}
                />
                <IndicatorCard
                  count={"0"}
                  label={"Active Students"}
                  bgcolor={"#71B37C"}
                  icon={"active-students"}
                  onClick={this.btnGetCardCountDetail.bind(this, "active")}
                  // chartType={"line"}
                  // chartData={activeuser_cardChartData}
                  // chartOption={activeuser_cardChartOpts}
                  // chartHeight={80}
                  popoverOpen={this.state.popoverOpen}
                  popoverId={"active"}
                  popoverDesp={"Total Number of Active Students"}
                  onInfobtnClick={this.cardInfoBoxtoggle.bind(this)}
                  disabled={true}
                />
                <IndicatorCard
                  count={"0"}
                  label={"Inactive Students"}
                  bgcolor={"#d93737"}
                  icon={"inactive-students"}
                  onClick={this.btnGetCardCountDetail.bind(this, "dormant")}
                  // chartType={"line"}
                  // chartData={inactiveuser_cardChartData}
                  // chartOption={inactiveuser_cardChartOpts}
                  // chartHeight={80}
                  popoverOpen={this.state.popoverOpen}
                  popoverId={"dormant"}
                  popoverDesp={"Total Number of Inactive Students"}
                  onInfobtnClick={this.cardInfoBoxtoggle.bind(this)}
                  disabled={true}
                />
              </Row>

              {/* ==================================== SUMMARY CARD BOX  - END ===================================== */}

              {/* ------------------------------------------------------------------------------------------------- */}
              <Row>
                <Col>
                  <Card>
                    <CardHeader>
                      <Button
                        block
                        color="link"
                        className="text-left m-0 p-0"
                        onClick={() => this.toggleGradeAccordion()}
                        aria-controls="collapseOne"
                      >
                        <i className="fa fa-university"></i>
                        <strong> Grade Wise Summary</strong>
                        <div className="card-header-actions">
                          <i
                            className={`fa ${
                              this.state.gradeAccordianFlag === true
                                ? "fa-minus-square"
                                : "fa-plus-square"
                            } `}
                            aria-hidden="true"
                          ></i>
                        </div>
                      </Button>
                    </CardHeader>
                    <Collapse isOpen={this.state.gradeAccordianFlag}>
                      <CardBody>
                        <Row>
                          <Col xs="12" md="12" className="mb-12">
                            <Nav tabs>
                              {/* {StudentGradeWiseAvg.map((object, i) =>
                            <NavItem key={i}>
                              <NavLink
                                key={i}
                                active={this.state.activeTab === object.gradeRoman}
                                onClick={() => { this.changeGradetoggleTab(object.gradeRoman, object.grade_id); }}
                              >
                                <i className="icon-calculator"></i> Grade - {object.gradeRoman}
                              </NavLink>
                            </NavItem>
                          )} */}
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                              {this.changeGradeFun(this.state.activeTab)}
                            </TabContent>
                          </Col>
                        </Row>
                        <br />
                      </CardBody>
                    </Collapse>
                  </Card>
                </Col>
              </Row>
            </BlockUi>
          </div>
        </div>
      );
    }
  }
}

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(withTranslation()(MasterSchoolDashboard));

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(MasterSchoolDashboard))
);
